import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MessageCountState {
    count: number;
}

const initialState: MessageCountState = {
    count: 0,
};

const messageCountSlice = createSlice({
    name: 'messageCount',
    initialState,
    reducers: {
        setCount: (state, action: PayloadAction<number>) => {
            state.count = action.payload;
        },
        increment: (state) => {
            state.count += 1;
        },
        decrement: (state) => {
            state.count = Math.max(0, state.count - 1);
        },
    },
});

export const { setCount, increment, decrement } = messageCountSlice.actions;

export default messageCountSlice.reducer;
